import { EpiBlock } from '@api/types';
import { BlockEditorMenu } from '@components';
import * as blocks from '@components/blocks';
import { getContentType } from '@utils/content.utils';
import React from 'react';

type Components = { [key: string]: any };

type BlockWrapperProperties = {
  wrapperComponent?: React.FC<any>;
  blockData?: EpiBlock;
  isEditMode?: boolean;
  enableContextMenu?: boolean;
  enableNativeOverlay?: boolean;
  disableEditPanel?: boolean;
  // Index signature - allows any other properties of any type
  [key: string]: any;
};

/**
 * Block Wrapper Component.
 * Maps CMS Block to React Component.
 * Data can have any type depends on the block type.
 * TODO [KF] - explore if this can be type-checked using Back End Types.
 */

export const BlockWrapper = (props: BlockWrapperProperties) => {
  // Declare all CMS Block here
  const components = blocks as Components;

  // Unwrap block data from Optimizely API
  const {
    blockData = {},
    wrapperComponent,
    enableContextMenu,
    disableEditPanel,
    enableNativeOverlay,
  } = props;
  const { contentLink = {} } = blockData;
  const block = contentLink?.expanded ? contentLink?.expanded : blockData;

  // Find block type name from block data
  const types = block?.contentType;
  const type = getContentType(types);

  // Check if this block has equivalent front end component
  // Component is matched by block name
  let Component = components[type];
  const children = Component ? (
    <Component key={contentLink.guidValue} {...block} disableEditPanel={disableEditPanel} />
  ) : null;
  return (
    <BlockEditorMenu
      id={contentLink.id}
      title={contentLink?.expanded?.name}
      enableContextMenu={enableContextMenu}
      enableNativeOverlay={enableNativeOverlay}
      block={block}
    >
      {wrapperComponent ? React.createElement(wrapperComponent, { children, block }) : children}
    </BlockEditorMenu>
  );
};
